// extracted by mini-css-extract-plugin
export default {"action-container":"simple-editor_action-container__CcXre","action-container__message":"simple-editor_action-container__message__HuZ2Y"};